<template>
  <div class="announcement-container" v-if="announcements.length > 0">
    <AnnouncementBar
      v-for="announcement in announcements"
      :key="announcement.id"
      :announcement="announcement"
    />
  </div>
</template>

<script>
import AnnouncementBar from "@/components/AnnouncementBar.vue";
import { mapState } from "vuex";

export default {
  components: {
    AnnouncementBar
  },
  computed: mapState("announcement", ["announcements"])
};
</script>

<style scoped>
.announcement-container {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 5px;
  max-height: 125px;
  overflow-y: auto;
}
</style>
